import { clsx } from 'clsx';

import LoadingSpinnerIcon from './loading-circle-spinner.svg?react';
import classes from './LoadingSpinner.module.css';

export type SmlLoadingSpinnerProps = {
    className?: string;
};

/**
 * SmlLoadingSpinner to show temporary state without specific progress information
 * @param props
 * @returns
 */
export const SmlLoadingSpinner = ({
    className,
}: SmlLoadingSpinnerProps): JSX.Element => {
    return (
        <div className={clsx(classes.smlLoadingSpinner, className)}>
            <LoadingSpinnerIcon vectorEffect="none" />
        </div>
    );
};
